import React from 'react';
import withStyles from 'react-jss';
import notFoundImg from 'src/assets/icons/notFound.svg';
import { useTranslation } from 'react-i18next';

const styles = (theme) => {
  return {
    message1: {
      textAlign: 'center',
      color: '1659CB',
    },
    message2: {
      marginTop: '2%',
      textAlign: 'center',
      color: '#4ABFE5',
    },
  };
};

const NotFound404 = (props: any) => {
  const { classes } = props;
  const { t } = useTranslation();
  return (
    <div>
      <div style={{ width: '100%', textAlign: 'center', marginTop: '20%' }}>
        <img className={classes.errorIcon} src={notFoundImg} alt="404 Icon" />
      </div>
      <div className={classes.message1}>{t('sorry')}!</div>
      <div className={classes.message2}>{t('The page you\'re looking for could not be found')}</div>
    </div>
  );
};

export default withStyles(styles, { injectTheme: true })(NotFound404);
